import React from "react";
import FlexBox from "view/components/Layout/FlexBox";
import {UploadIcon} from "view/components/TaskDrawer/icons";
import {blue} from "@material-ui/core/colors";
import {IconButton, Typography, useTheme} from "@material-ui/core";
import SettingsIcon from "view/images/SettingsIcon";
import RequiredIcon from "view/components/GridResponseBlock/CustomizeTable/Components/Rows/Cell/RequiredIcon";
import useStyles from "./styles";

type FilesInputProps = {
  isRequired: boolean;
  isActive: boolean;
  onClickSettings: () => void;
  onClickMandatory: () => void;
  viewOnly?: boolean;
};
const FilesInput = ({
  isRequired,
  isActive,
  viewOnly,
  onClickSettings,
  onClickMandatory,
}: FilesInputProps) => {
  const theme = useTheme();
  const classes = useStyles();
  const shouldDisplayIcon = !viewOnly || isRequired;

  return (
    <>
      <FlexBox
        alignCenter
        gap={1}
        justifyContent="space-between"
        className={classes.fileViewContainer}
      >
        <FlexBox alignCenter gap={0.5}>
          <UploadIcon
            color={theme.palette.contrastIcon.main}
            width={16}
            height={16}
          />
          <Typography
            variant="h5"
            style={{color: theme.palette.contrastText.main, lineHeight: 1.1}}
          >
            File Upload
          </Typography>
        </FlexBox>
        {shouldDisplayIcon && (
          <RequiredIcon
            onClick={onClickMandatory}
            isRequired={isRequired}
            viewOnly={viewOnly}
          />
        )}
      </FlexBox>
      {!viewOnly && (
        <IconButton className={classes.cellButton} onClick={onClickSettings}>
          <SettingsIcon fill={isActive ? blue.A100 : undefined} />
        </IconButton>
      )}
    </>
  );
};

export default FilesInput;
